import { Middleware } from '@reduxjs/toolkit'

// Middleware для автоматичного збереження корзини в localStorage
export const cartMiddleware: Middleware = store => next => action => {
  const result = next(action)

  // Перевіряємо, чи це дія, пов'язана з корзиною
  if (
    typeof action === 'object' &&
    action &&
    'type' in action &&
    typeof action.type === 'string' &&
    action.type.startsWith('cart/')
  ) {
    const cartState = store.getState().cart
    try {
      localStorage.setItem('cart', JSON.stringify(cartState.items))
    } catch (error) {
      // Помилка збереження корзини в localStorage
    }
  }

  return result
}
